import React, { useEffect, useState } from "react";

function TerminalText({ phrases }) {
  const [index, setIndex] = useState(0);
  const [length, setLength] = useState(0);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    const phrase = phrases[index];
    const doneTyping = length === phrase.length;
    const doneDeleting = length === 0;
    const delay = doneTyping && !deleting ? 1200 : deleting ? 34 : 64;
    const timer = window.setTimeout(() => {
      if (doneTyping && !deleting) {
        setDeleting(true);
      } else if (doneDeleting && deleting) {
        setDeleting(false);
        setIndex((value) => (value + 1) % phrases.length);
      } else {
        setLength((value) => value + (deleting ? -1 : 1));
      }
    }, delay);

    return () => window.clearTimeout(timer);
  }, [deleting, index, length, phrases]);

  return (
    <span className="terminal-text" aria-live="polite">
      {phrases[index].slice(0, length)}
      <span className="terminal-caret" aria-hidden="true" />
    </span>
  );
}

export default TerminalText;
